document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".episode-card__watch-trigger");
  const modal = document.querySelector(".video-modal");
  const iframe = document.getElementById("embed-iframe");
  const overlay = document.querySelector(".video-overlay");
  const closeModal = document.querySelector(".video-modal-close");

  if (triggers) {
    triggers.forEach(trigger => {
      trigger.addEventListener("click", (e) => {
        console.log('open modal');
        const url = trigger.getAttribute("data-url");

        if (url && (url.includes("youtube.com") || url.includes("youtu.be"))) {
          let videoId = new URL(url).searchParams.get("v");
          if (!videoId && url.includes("youtu.be")) {
            videoId = url.substring(url.lastIndexOf("/") + 1);  // Extract videoId for shortened YouTube URLs (youtu.be)
          }
          const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&modestbranding=1&showinfo=0&rel=0&mute=1`;

          iframe.src = embedUrl;
          modal.style.display = "flex";
          overlay.style.display = "block";
        }
      });
    });
  }

  // Close modal
  closeModal.addEventListener("click", () => {
    modal.style.display = "none";
    overlay.style.display = "none";
    iframe.src = "";
  });

  // Close modal if clicking outside
  overlay.addEventListener("click", (event) => {
      modal.style.display = "none";
      overlay.style.display = "none";
      iframe.src = "";
  });
});
